import React from 'react';
import PropTypes from 'prop-types';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const AgentResult = (props) => {

    const setAgentName = (e) => {
        e.target.style.display = 'none';
        e.target.nextElementSibling.classList.add('show');
    }

    return(
        <div className="partner-result">
            <h6>
                {translateStaticContent('agentHeader', 
                    props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
            </h6>
            <div className="listAgents">
                {props.result.map(agent => {
                    let websiteLink = '';
                    const isHtts = agent.websiteLink.indexOf('http');
                    if (isHtts === -1) {
                        websiteLink = 'https://' + agent.websiteLink;
                    } else {
                        websiteLink = agent.websiteLink;
                    }
                    return  <a href={websiteLink} key={agent.id} target='_blank' rel='noreferrer'>
                                <img src={`data:${agent.logoMediaType};base64,${agent.logoFile}`} 
                                className="partner-logo" onError={setAgentName}  referrerPolicy="no-referrer"/>
                                <span className="agentName">{agent.name}</span>
                            </a>
                })} 
            </div>
        </div>
    )
}

export default AgentResult;

AgentResult.propTypes = {
    result: PropTypes.array.isRequired,
    defaultStaticContentCalc: PropTypes.object,
    activeLangStaticContentCalc: PropTypes.object,
}